import React from "react";
import { CheckCircle } from "lucide-react";

const whatsappLeadsData = [
  {
    heading: "Browse Products & Place Orders Seamlessly",
    points: [
      "Showcase your retail products on WhatsApp with ChatMitra’s catalog feature.",
      "Answer customer queries instantly with WhatsApp chatbots or live support.",
      "Enable direct order placement within WhatsApp for a smooth shopping experience.",
      "Increase conversions with 95% open rates compared to 20% for email.",
    ],
    buttonText: "Try ChatMitra for Growth",
    buttonLink:"https://app.chatmitra.com/signin",
    image: "https://umsousercontent.com/lib_EyxlwrMuBuWXHRhZ/z68mll0p7l0a3lee.webp",
  },
  {
    heading: "Personalized Promotions & Exclusive Deals",
    points: [
      "Send tailored discounts and offers via WhatsApp to boost sales.",
      "Use customer data for personalized product recommendations.",
      "Drive repeat purchases with timely, targeted retail promotions.",
      "Enjoy 45-60% click-through rates with WhatsApp campaigns.",
    ],
    image: "https://umsousercontent.com/lib_EyxlwrMuBuWXHRhZ/c88f3utdkytr4ge0.webp",
  },
  {
    heading: "5x More Leads with Click-to-WhatsApp Ads",
    points: [
      "Convert social media traffic from Facebook and Instagram to WhatsApp.",
      "Capture leads instantly with names and numbers via ChatMitra.",
      "Engage prospects directly for higher customer engagement.",
      "Turn clicks into loyal retail customers effortlessly.",
    ],
    buttonText: "Try ChatMitra for Growth",
    buttonLink:"https://app.chatmitra.com/signin",
    image: "https://umsousercontent.com/lib_EyxlwrMuBuWXHRhZ/i66f25ivo1rteqgo.png",
  },
  {
    heading: "Instant Customer Support & Product Queries",
    points: [
      "Resolve inquiries fast with WhatsApp chatbots powered by ChatMitra.",
      "Handle returns, exchanges, and policies seamlessly.",
      "Escalate complex issues to live agents in real-time.",
      "Improve satisfaction with 70% engagement rates.",
    ],
    image: "https://umsousercontent.com/lib_EyxlwrMuBuWXHRhZ/foypkzd72uxb3ylm.png",
     // buttonText: "Get Start ",
     buttonText: "Meta Policy for Offline and Retail",
     buttonLink:"https://transparency.meta.com/policies/ad-standards/",
  },
  {
    heading: "Easy In-Store Appointment Scheduling",
    points: [
      "Automate bookings for salons, spas, or retail consultations via WhatsApp.",
      "Send instant confirmations to reduce no-shows.",
      "Simplify scheduling without phone calls or emails.",
      "Enhance customer convenience with ChatMitra’s tools.",
    ],
    buttonText: "Try ChatMitra for Growth",
    buttonLink:"https://app.chatmitra.com/signin",
    image: "https://umsousercontent.com/lib_EyxlwrMuBuWXHRhZ/7jfx0acsznptp4zx.png",
  },
  {
    heading: "Collect Feedback & Build Trust",
    points: [
      "Request reviews post-purchase via WhatsApp for quick responses.",
      "Show customers their opinions matter with personalized follow-ups.",
      "Use insights to refine your retail automation strategy.",
      "Boost credibility with positive feedback shared online.",
    ],
    image: "https://umsousercontent.com/lib_EyxlwrMuBuWXHRhZ/6oje4m2i9n81u54v.webp",
  },
];

const Retailcycle = () => {
  return (
    <>
      <div className="flex flex-col justify-center items-center text-center h-52 sm:h-64 md:h-72 lg:h-80 px-6 py-4 bg-gradient-to-r from-blue-200 via-blue-300 to-blue-400 shadow-lg rounded-lg">
        <h1 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold leading-tight max-w-4xl text-gray-900">
          How WhatsApp for Retail Transforms Your Business
        </h1>
        <div className="w-16 h-1 bg-gray-600 my-4 rounded-full"></div>
        <p className="text-sm sm:text-lg md:text-xl text-gray-800 max-w-3xl mt-2 md:mt-4 px-2">
          Discover how ChatMitra empowers retailers with WhatsApp to showcase products, send promotions, automate orders, and enhance support.
        </p>
      </div>
      <div className="flex flex-col gap-20 sm:gap-20 bg-white max-w-6xl mx-auto mt-10 mb-10 px-4 sm:px-0">
        {whatsappLeadsData.map((item, index) => (
          <section
            key={index}
            className={`flex flex-col md:flex-col lg:flex-row items-center justify-between gap-16 sm:gap-20 ${
              index % 2 === 1 ? "lg:flex-row-reverse" : ""
            }`}
          >
            <div className="lg:w-1/2 md:w-full flex justify-center mb-4 lg:mb-0">
              <img
                src={item.image}
                alt={`${item.heading} with ChatMitra`}
                className="max-w-full h-auto rounded-lg border-transparent transition-all duration-500"
              />
            </div>
            <div className="w-full md:w-full lg:w-1/2 text-left md:p-5">
              <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 leading-tight">{item.heading}</h2>
              <ul className="mt-6 space-y-4 text-lg text-gray-700">
                {item.points.map((point, i) => (
                  <li key={i} className="flex items-start space-x-3">
                    <CheckCircle className="text-[#075E54] w-4 h-4 self-center flex-shrink-0" strokeWidth={3} />
                    <span className="leading-relaxed">{point}</span>
                  </li>
                ))}
              </ul>
              {item.buttonText && (
                <a
                href={item.buttonLink}
                className="mt-6 inline-block bg-[#075E54] text-white py-3 px-6 rounded-lg hover:bg-[#064d40] transition-colors"
              >
                {item.buttonText}
              </a>
              )}
            </div>
          </section>
        ))}
      </div>
    </>
  );
};

export default Retailcycle;